
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/nl/en/accessibility",
      function () {
        return require("private-next-pages/nl/en/accessibility.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/nl/en/accessibility"])
      });
    }
  